'use strict';exports.__esModule = true;exports.unitePropertyTypesByOptions = exports.unitePropertyTypesBySections = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _union = require('lodash/union');var _union2 = _interopRequireDefault(_union);
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var unitePropertyTypesBySections = exports.unitePropertyTypesBySections = function unitePropertyTypesBySections(sortedPropertyTypes) {var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.optionTypes.buy;
  var sectionNames = Object.keys(_constants.sections);

  var types = sectionNames.map(function (item) {
    var sectionValue = (0, _get2.default)(_constants.sections, item + '.value');
    return (0, _get2.default)(sortedPropertyTypes, sectionValue + '.' + option);
  });

  return _union2.default.apply(undefined, types);
};

var unitePropertyTypesByOptions = exports.unitePropertyTypesByOptions = function unitePropertyTypesByOptions(sortedPropertyTypes) {var section = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.sections.homes.value;
  var options = Object.keys(_constants.optionTypes);
  var types = options.map(function (option) {return (0, _get2.default)(sortedPropertyTypes, section + '.' + option);});

  return _union2.default.apply(undefined, types);
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatPropertyTypes.js
// module id = 601
// module chunks = 0